module.exports = __webpack_public_path__ + "static/media/copy-icon.0604c50b.svg";